import {GetAdherenceDigitalPaymentParams} from 'domain/usecases';
import {makeGetAdherenceDigitalPayment} from 'main/factories/usecases';

export const getAdherenceDigitalPayment = (params: GetAdherenceDigitalPaymentParams) =>
	makeGetAdherenceDigitalPayment().get(params);
